import { Component, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Service } from 'src/app/services/interface';
import { ServicesService } from 'src/app/services/services.service';
import { UploadService } from 'src/app/_shared/services/upload.service';
import { BUCKET_URL } from 'src/app/_shared/utils/constants';
import { getDirtyValues } from 'src/app/_shared/utils/form';
import Swal from 'sweetalert2';
import { ServiceFormService } from '../service-form.service';

@Component({
  selector: 'app-service-action-bar',
  templateUrl: './service-action-bar.component.html',
  styleUrls: ['./service-action-bar.component.scss']
})
export class ServiceActionBarComponent implements OnInit {

  service: Service
  isLoading: boolean;
  uploadingImage: boolean;
  constructor(
    private servicesService: ServicesService,
    private serviceFormService: ServiceFormService,
    private uploadService: UploadService,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.serviceFormService.service$.subscribe(val => {
      this.service = val
    })
  }
  deleteService() {
    this.isLoading = true
    this.servicesService.deleteService(this.service.id).subscribe(res => {
      this.isLoading = false
      this.router.navigate(['/services']);
      Swal.fire({
        title: 'Service successfully deleted',
        type: 'success',
        timer: 2000
      })
    }, err => {
      this.isLoading = false
      Swal.fire({
        title: "Error",
        text: err.error.message,
        type: "error",
        timer: 2000,
      });
    });
  }

  get formControls() {
    return this.serviceFormService.serviceFormGroup.controls
  }

  get serviceFormGroup() {
    return this.serviceFormService.serviceFormGroup
  }

  public onSubmit() {
    this.isLoading = true;
    if (this.service && this.service.id) {
      const values = getDirtyValues(this.serviceFormGroup) as any;
      if (values.show_discount || values.discount_rate) {
        // remove the values
        values.discount = {
          rate: parseFloat(this.serviceFormGroup.controls.discount_rate.value),
          show: JSON.parse(this.serviceFormGroup.controls.show_discount.value)
        }
      }
      this.servicesService.updateService(this.service.id, values).subscribe(res => {
        this.isLoading = false;
        Swal.fire({
          title: 'Service successfully updated',
          type: 'success',
          timer: 2000
        })
      }, err => {
        this.isLoading = false;
        Swal.fire({
          title: "Error",
          text: err.error.message,
          type: "error",
          timer: 2000,
        });
      })
      return
    }
    this.servicesService.createService(this.serviceFormGroup.value).subscribe(val => {
      this.isLoading = false;
      Swal.fire({
        title: 'Service successfully created',
        type: 'success',
        timer: 2000
      })
      this.router.navigate(['services', val.id])
    }, err => {
      this.isLoading = false;
      Swal.fire({
        title: "Error",
        text: err.error.message,
        type: "error",
        timer: 2000,
      });
    })
  }


  get isValidForm() {
    return this.serviceFormService.serviceFormGroup.valid
  }

  public previewImage(event: any) {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      this.uploadingImage = true;
      this.uploadService.upload(formData).subscribe(
        (res) => {
          const control = this.formControls.icon
          this.uploadingImage = false;
          control.patchValue(res.image_url);
          control.markAsDirty();
        },
        (err) => {
          this.uploadingImage = false;
          let message = "Server error";
          if (err.status && err.status == 400) {
            message = err.error.message;
          }
          Swal.fire({
            title: "Image upload failed",
            text: message,
            type: "error",
            timer: 2000,
          });
        }
      );
    }
  }

  get iconUrl() {
    const control = this.formControls.icon
    const value: string = control.value
    if (value && value.includes('http')) {
      return value
    }
    return control.value ? BUCKET_URL + control.value : 'https://via.placeholder.com/150?text=admin.ezyagric.com'
  }
}
